<template>
  <!-- 产品中心 start -->
  <div class="product-menu">
    <div class="menu-inline" v-if="IsPC()">
      <ul class="product-m-left">
        <li v-for="(item, index) in productList" :key="index" :class="{ 'is-active': productIndex == index }"
          @mouseover.stop="toggelProduct(index)">
          <div class="p-l-img">
            <img :src="item.icon" alt="">
          </div>
          <div class="p-l-text">
            <div>{{ item.name }}</div>
            <div>{{ item.content }}</div>
          </div>
        </li>
      </ul>
      <div class="product-m-right pro-m-right">
        <div class="pro-m-s" v-loading="loading">
          <!-- <div class="product-title">{{item.name}}</div> -->
          <el-row type="flex" class="row-wrap" :gutter="20">
            <el-col :span="8" v-for="(info, index) in productInfo" :key="index + '_2'">
              <div class="pro-m-one" @click.stop="goProPage(info)" :style="'background-image: url(' + info.menuIcon + ')'">
                <div class="pro-title">{{ info.name }}</div>
                <div class="pro-text twoline">{{ info.des }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="menu-app-inline" v-else>
      <div class="menu-box-one" v-for="(item, index) in appProductList" :key="index">
        <div class="menu-one-left">{{ item.name }}</div>
        <div class="menu-one-right">
          <el-row type="flex" class="row-wrap" :gutter="10">
            <el-col :span="12" v-for="(info, index) in item.list" :key="index + '_2'">
              <div @click.stop="goProPage(info)" class="menu-col"
                :class="{ 'menu-col-1': info.id === '2-1-1' || info.id === '2-2-1' }"
                :style="'background-image: url(' + info.menuIcon + ')'">{{ info.name }}</div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
  <!-- 产品中心 end -->
</template>

<script>
import { productList } from "@/views/product/productInfo"
import { IsPC } from "@/utils"
export default {
  data() {
    return {
      productIndex: 0,
      productList,
      loading: false
    }
  },
  computed: {
    productInfo() {
      this.loading = true
      let list = []
      let list1 = this.productList[this.productIndex].list
      list1.forEach(item => {
        let list2 = item.list.filter(item => item.menuIcon)
        list = list.concat(list2)
      })
      // setTimeout(() => {
      this.loading = false
      // }, 100)
      // console.log(list);
      return list
    },
    appProductList() {
      let newList = JSON.parse(JSON.stringify(this.productList))
      newList.forEach(item => {
        let list = []
        item.list.forEach(val => {
          let list2 = val.list.filter(item => item.menuIcon)
          list = list.concat(list2)
        })
        item.list = list
      })
      // console.log(newList);

      return newList
    }
  },
  methods: {
    IsPC,
    toggelProduct(index) {
      this.productIndex = index
    },
    goProPage(info) {
      if (!this.IsPC()) {
        this.$emit('closeMenu', 1)
      }
      if (info.path) {
        this.$router.push({
          path: info.path
        })
      } else {
        this.$router.push({
          path: '/productDetails',
          query: {
            id: info.id
          }
        })
      }
    },
  }
}
</script>


<style lang="scss" scoped>@import '~@/styles/menu.scss';</style>


// WEBPACK FOOTER //
// src/views/components/menu-product.vue